import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof2 from "@babel/runtime/helpers/esm/typeof";
import React, { useState, Component, useEffect, useRef, Fragment } from 'react';
import { View, Dimensions, PanResponder, Platform, ScrollView, TouchableOpacity, Text, StyleSheet, Animated, Image } from 'react-native-web';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { parseToRgb, setLightness } from 'polished';
import PropTypes from 'prop-types';
import factoryWithTypeCheckers from 'prop-types/factoryWithTypeCheckers';
import { useSpring, animated } from 'react-spring';
import Svg, { Defs, Stop, Rect, LinearGradient, Path, G } from 'swgs';
import ReactDOM from 'react-dom';

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof2(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof2(call) === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

function isObject(item) {
  return item && (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" && !Array.isArray(item);
}

function mergeDeep(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) return target;
  var source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (var key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, defineProperty({}, key, {}));
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, defineProperty({}, key, source[key]));
      }
    }
  }

  return mergeDeep.apply(undefined, [target].concat(sources));
}

var UniProvider = function UniProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var width = Dimensions.get("window").width;
  var height = Dimensions.get("window").height;

  var _useState = useState({
    width: width,
    height: height
  }),
      _useState2 = slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var defaultTheme = {
    unikit: {
      layout: {
        width: state.width,
        height: state.height
      },
      colors: {
        primary: "#FF6B87",
        success: "#4CAF50",
        text: "#FF6B87"
      },
      breaks: {
        mobile: 768,
        tablet: 1024,
        desktop: 99999
      },
      box: {
        shadowColor: "rgba(0,0,0,0.2)"
      },
      overlay: {
        backgroundColor: "#FFF"
      },
      avatar: {
        backgroundColor: "primary",
        size: 60
      },
      progress: {
        trackColor: "rgba(0,0,0,0.05)",
        circleColor: "primary"
      },
      button: {
        mode: "primary",
        colors: ["#FF6B87", "rgb(255,0,0)"],
        inline: true,
        activeOpacity: 0.6,
        size: 44,
        borderRadius: 22
      },
      switch: {
        circleSize: 25,
        borderSize: 5,
        borderRadius: 30
      },
      select: {
        mode: "primary",
        size: 60,
        height: 50,
        indicatorHeight: 50,
        borderRadius: 25
      },
      text: {
        lineHeight: 25,
        fontSize: 16
      },
      headline: {
        level: 1,
        fontSize: 50
      },
      table: {
        headBackground: "#FFF",
        bodyBackground: "primary",
        bodyBackgroundLightness: 0.96
      },
      gradient: {
        colors: ["#FF6B87", "rgb(255,0,0)"]
      }
    }
  };
  return React.createElement(ThemeProvider, {
    theme: mergeDeep(defaultTheme, theme)
  }, React.createElement(View, {
    style: {
      flex: 1
    },
    onLayout: function onLayout(_ref2) {
      var nativeEvent = _ref2.nativeEvent;
      setState({
        width: nativeEvent.layout.width,
        height: nativeEvent.layout.height
      });
    }
  }, children));
};

var Visible = function (_Component) {
  inherits(Visible, _Component);

  function Visible(props) {
    classCallCheck(this, Visible);

    var _this = possibleConstructorReturn(this, (Visible.__proto__ || Object.getPrototypeOf(Visible)).call(this, props));

    _this.state = {
      rectTop: 0,
      rectBottom: 0,
      isVisible: false
    };
    return _this;
  }

  createClass(Visible, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.disabled) {
        this.startWatching();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopWatching();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.stopWatching();
      } else {
        this.lastValue = null;
        this.startWatching();
      }
    }
  }, {
    key: "startWatching",
    value: function startWatching() {
      var _this2 = this;

      if (this.interval) {
        return;
      }

      this.interval = setInterval(function () {
        if (!_this2.myview) {
          return;
        }

        _this2.myview.measure(function (x, y, width, height, pageX, pageY) {
          _this2.setState({
            rectTop: pageY,
            rectBottom: pageY + height,
            rectWidth: pageX + width
          });
        });

        _this2.isInViewPort();
      }, this.props.delay || 100);
    }
  }, {
    key: "stopWatching",
    value: function stopWatching() {
      this.interval = clearInterval(this.interval);
    }
  }, {
    key: "isInViewPort",
    value: function isInViewPort() {
      var window = Dimensions.get("window");
      var isVisible = this.state.rectBottom != 0 && this.state.rectTop >= 0 && this.state.rectBottom <= window.height && this.state.rectWidth > 0 && this.state.rectWidth <= window.width;

      if (this.lastValue !== isVisible) {
        this.lastValue = isVisible;
        this.setState({
          isVisible: isVisible
        });
        this.props.onChange(isVisible);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement(View, _extends({
        collapsable: false,
        ref: function ref(component) {
          _this3.myview = component;
        }
      }, this.props), this.props.children instanceof Function ? this.props.children({
        isVisible: this.state.isVisible
      }) : this.props.children);
    }
  }]);
  return Visible;
}(Component);

var getObjValue = function getObjValue(o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties

  s = s.replace(/^\./, ""); // strip a leading dot

  var a = s.split(".");

  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];

    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }

  return o;
};

var lightOrDark = function lightOrDark(color) {
  if (!color) return false;

  var _parseToRgb = parseToRgb(color),
      red = _parseToRgb.red,
      green = _parseToRgb.green,
      blue = _parseToRgb.blue;

  if (red * 0.299 + green * 0.587 + blue * 0.114 > 186) {
    return true;
  } else {
    return false;
  }
};

var getProp = function getProp(props, key, comp) {
  var unikitTheme = props.theme ? props.theme.unikit : {};
  var value = undefined;

  if (props[key] !== undefined) {
    value = props[key];
  } else if (getObjValue(unikitTheme, comp + "." + key) !== undefined) {
    value = getObjValue(unikitTheme, comp + "." + key);
  } else if (getObjValue(unikitTheme, "box." + key) !== undefined) {
    value = getObjValue(unikitTheme, "box." + key);
  } else if (getObjValue(unikitTheme, "colors." + key) !== undefined) {
    value = getObjValue(unikitTheme, "colors." + key);
  }

  if (getObjValue(unikitTheme, "colors." + value)) {
    value = getObjValue(unikitTheme, "colors." + value);
  }

  if (props[key + "Lightness"] || getObjValue(unikitTheme, comp + "." + key + "Lightness")) {
    value = setLightness(props[key + "Lightness"] || getObjValue(unikitTheme, comp + "." + key + "Lightness"), value);
  }

  return value;
};

var getColorSchema = function getColorSchema(props, color, type) {
  var newColor = color;
  if (!newColor) return {};
  var lightness = getProp(props, "lightness", "global") || 0.94;

  if (type === "light") {
    newColor = setLightness(lightness, newColor);
  }

  var dark = lightOrDark(newColor);
  return {
    background: newColor,
    text: dark ? color : "#FFF"
  };
};

var constant = {
  RESISTANCE_COEF: 0.6,
  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px

};
var swipeDirections = {
  SWIPE_UP: "SWIPE_UP",
  SWIPE_DOWN: "SWIPE_DOWN",
  SWIPE_LEFT: "SWIPE_LEFT",
  SWIPE_RIGHT: "SWIPE_RIGHT"
};
var swipeConfig = {
  velocityThreshold: 0.3,
  directionalOffsetThreshold: 80,
  gestureIsClickThreshold: 5
};

function isValidSwipe(velocity, velocityThreshold, directionalOffset, directionalOffsetThreshold) {
  return Math.abs(velocity) > velocityThreshold && Math.abs(directionalOffset) < directionalOffsetThreshold;
}

var Pan = function (_Component) {
  inherits(Pan, _Component);

  function Pan(props, context) {
    classCallCheck(this, Pan);

    var _this = possibleConstructorReturn(this, (Pan.__proto__ || Object.getPrototypeOf(Pan)).call(this, props, context));

    _this.onMove = function (evt, gestureState) {
      var swipeDirection = _this._getSwipeDirection(gestureState);

      _this.props.onSwipe && _this.props.onSwipe(swipeDirection, gestureState);
    };

    _this.onEnd = function (evt, gestureState) {
      var swipeDirection = _this._getSwipeDirection(gestureState);

      if (_this.props.onSwipeEnd) {
        _this.props.onSwipeEnd(swipeDirection, gestureState);
      }
    };

    _this.onStart = function (event, gestureState) {
      console.log("onStart");

      if (_this.props.onStart) {
        _this.props.onStart(event, gestureState);
      }
    };

    _this._handlePanResponderEnd = function (evt, gestureState) {
      var swipeDirection = _this._getSwipeDirection(gestureState);

      if (_this.props.onSwipeEnd) {
        _this.props.onSwipeEnd(swipeDirection, gestureState);
      }

      _this._triggerSwipeHandlers(swipeDirection, gestureState);
    };

    _this.swipeConfig = Object.assign(swipeConfig, props.config);
    return _this;
  }

  createClass(Pan, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.swipeConfig = Object.assign(swipeConfig, props.config);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var responderEnd = this._handlePanResponderEnd.bind(this);

      var shouldSetResponder = this._handleShouldSetPanResponder.bind(this);

      this._panResponder = PanResponder.create({
        //stop JS beautify collapse
        onStartShouldSetPanResponder: function onStartShouldSetPanResponder() {
          return true;
        },
        onMoveShouldSetPanResponder: function onMoveShouldSetPanResponder(event, gestureState) {
          var dx = Math.abs(gestureState.dx);
          var dy = Math.abs(gestureState.dy);
          return dx > dy && dx > constant.UNCERTAINTY_THRESHOLD;
        },
        onPanResponderMove: this.onMove,
        onPanResponderRelease: this.onEnd,
        onPanResponderTerminate: this.onEnd,
        onPanResponderGrant: this.onStart
      });
    }
  }, {
    key: "_handleShouldSetPanResponder",
    value: function _handleShouldSetPanResponder(evt, gestureState) {
      return evt.nativeEvent.touches.length === 1 && !this._gestureIsClick(gestureState);
    }
  }, {
    key: "_gestureIsClick",
    value: function _gestureIsClick(gestureState) {
      return Math.abs(gestureState.dx) < swipeConfig.gestureIsClickThreshold && Math.abs(gestureState.dy) < swipeConfig.gestureIsClickThreshold;
    }
  }, {
    key: "_getSwipeDirection",
    value: function _getSwipeDirection(gestureState) {
      var SWIPE_LEFT = swipeDirections.SWIPE_LEFT,
          SWIPE_RIGHT = swipeDirections.SWIPE_RIGHT,
          SWIPE_UP = swipeDirections.SWIPE_UP,
          SWIPE_DOWN = swipeDirections.SWIPE_DOWN;
      var dx = gestureState.dx,
          dy = gestureState.dy;

      if (this._isValidHorizontalSwipe(gestureState)) {
        return dx > 0 ? SWIPE_RIGHT : SWIPE_LEFT;
      } else if (this._isValidVerticalSwipe(gestureState)) {
        return dy > 0 ? SWIPE_DOWN : SWIPE_UP;
      }

      return null;
    }
  }, {
    key: "_isValidHorizontalSwipe",
    value: function _isValidHorizontalSwipe(gestureState) {
      var vx = gestureState.vx,
          dy = gestureState.dy;
      var _swipeConfig = this.swipeConfig,
          velocityThreshold = _swipeConfig.velocityThreshold,
          directionalOffsetThreshold = _swipeConfig.directionalOffsetThreshold;
      return isValidSwipe(vx, velocityThreshold, dy, directionalOffsetThreshold);
    }
  }, {
    key: "_isValidVerticalSwipe",
    value: function _isValidVerticalSwipe(gestureState) {
      var vy = gestureState.vy,
          dx = gestureState.dx;
      var _swipeConfig2 = this.swipeConfig,
          velocityThreshold = _swipeConfig2.velocityThreshold,
          directionalOffsetThreshold = _swipeConfig2.directionalOffsetThreshold;
      return isValidSwipe(vy, velocityThreshold, dx, directionalOffsetThreshold);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(View, _extends({}, this.props, this._panResponder.panHandlers));
    }
  }]);
  return Pan;
}(Component);

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var ensureDevPropTypes = createCommonjsModule(function (module) {
  var _propTypes2 = _interopRequireDefault(PropTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return _typeof2(object) === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  var devPropTypes = factoryWithTypeCheckers(isValidElement, true);
  Object.keys(_propTypes2.default).forEach(function (key) {
    _propTypes2.default[key] = devPropTypes[key];
  });
});
unwrapExports(ensureDevPropTypes);
var dist = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  /* eslint-disable no-param-reassign, no-use-before-define */


  var _propTypes2 = _interopRequireDefault(PropTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var mutatePropType = function mutatePropType(name) {
    var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _propTypes2.default[name];
    object.type = _extends({}, object.type, {
      name: name
    });

    if (object.isRequired) {
      object.isRequired.required = true;
      Object.keys(object).filter(function (key) {
        return !["isRequired"].includes(key);
      }).forEach(function (key) {
        object.isRequired[key] = object[key];
      });
      mutatePropType(name, object.isRequired);
    }
  };

  var mutatePropTypeFn = function mutatePropTypeFn(name) {
    var original = _propTypes2.default[name];

    _propTypes2.default[name] = function (arg) {
      var object = original(arg);

      if (typeof arg === "function" && arg.name.indexOf("checkType") >= 0) {
        // arrayOf
        object.type = {
          value: parsePropTypeMethod(arg).type
        };
      } else if (typeof arg === "function") {
        // instanceOf
        object.type = {
          value: arg.name
        };
      } else if (Array.isArray(arg) && typeof arg[0] === "function") {
        // oneOfType
        object.type = {
          value: arg.map(function (method) {
            return parsePropTypeMethod(method).type;
          })
        };
      } else if (!Array.isArray(arg) && _typeof2(arg) === "object") {
        // shape
        object.type = {
          value: parsePropTypes({
            propTypes: arg
          })
        };
      } else {
        // oneOf
        object.type = {
          value: arg
        };
      }

      mutatePropType(name, object);
      return object;
    };
  };

  Object.keys(_propTypes2.default).filter(function (type) {
    return !["exact", "checkPropTypes", "PropTypes"].includes(type);
  }).forEach(function (type) {
    if (_propTypes2.default[type].isRequired) {
      return mutatePropType(type);
    }

    return mutatePropTypeFn(type);
  });

  var parsePropTypeMethod = function parsePropTypeMethod(_ref, value) {
    var isRequired = _ref.isRequired,
        method = _objectWithoutProperties(_ref, ["isRequired"]);

    return _extends({
      type: {
        name: "custom"
      },
      required: false
    }, typeof value !== "undefined" ? {
      defaultValue: {
        value: value
      }
    } : {}, method);
  };
  /** */


  var parsePropTypes = function parsePropTypes(_ref4) {
    var _ref4$propTypes = _ref4.propTypes,
        propTypes = _ref4$propTypes === void 0 ? {} : _ref4$propTypes,
        _ref4$defaultProps = _ref4.defaultProps,
        defaultProps = _ref4$defaultProps === void 0 ? {} : _ref4$defaultProps;
    return Object.keys(propTypes).reduce(function (parsed, prop) {
      return _extends({}, parsed, _defineProperty({}, prop, parsePropTypeMethod(propTypes[prop], defaultProps[prop])));
    }, {});
  };

  exports.default = parsePropTypes;
});
unwrapExports(dist);

var _templateObject = taggedTemplateLiteral(["\n", "\n  ", "\n  ", "\n"], ["\n", "\n  ", "\n  ", "\n"]); // import styles from "./styles.css";


var ColorStyles$1 = ["color", "backgroundColor", "borderColor"];
var BasicStyles = ["position", "width", "height", "maxWidth", "maxHeight", "minWidth", "minHeight", "fontSize", "borderWidth", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "padding", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "flex", "flexWrap", "flexDirection", "alignItems", "justifyContent", "opacity", "borderRadius", "top", "left", "right", "bottom", "zIndex", "fontSize", "lineHeight", "overflow", "borderWidth", "borderColor", "border"];
var noPixel = ["opacity", "zIndex"];

var toString = function toString(value, key) {
  if (typeof value === "number") {
    var add = noPixel.indexOf(key) > -1 ? "" : "px";
    value = value.toString() + add;
  }

  return value;
};

var getBreak = function getBreak(layout, breaks, value) {
  var breaksArray = Object.values(breaks);
  var index = breaksArray.findIndex(function (item) {
    return item > layout.width;
  });
  return value ? value[index] : undefined;
};

var mapProps = function mapProps() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var styleString = "";
  var theme = props.theme.unikit;
  var compProps = theme[props.comp] || {};
  var breaks = props.theme.unikit.breaks || {
    mb: 0,
    tb: 768,
    dt: 1024
  };
  var p = Object.assign({}, compProps, props);
  Object.keys(p).map(function (key, index) {
    if (BasicStyles.indexOf(key) > -1) {
      var value = getProp(p, key, p.comp);

      if (typeof value === "string" || typeof value === "number") {
        value = toString(value, key);
      } else {
        value = getBreak(theme.layout, breaks, value);
      }

      styleString += key.replace(/([a-z])([A-Z])/g, "$1-$2") + ": " + value + ";";
    } else if (ColorStyles$1.indexOf(key) > -1) {
      var color = getProp(p, key, p.comp);

      if (p[key + "Lightness"]) {
        color = setLightness(p[key + "Lightness"], color);
      }

      styleString += key.replace(/([a-z])([A-Z])/g, "$1-$2") + ": " + color + ";";
    }
  });
  return styleString;
};

var defaultStyle = "\n  margin: unset;\n  padding: unset;\n  border: unset;\n  background: unset;\n  font-size: 100%;\n  box-sizing: border-box;\n";
var Box = styled(View)(_templateObject, Platform.OS === "web" && defaultStyle, function (p) {
  return getProp(p, "shadow", p.comp || "box") && "box-shadow: 0px 2px " + getProp(p, "shadow", p.comp || "box") + "px " + getProp(p, "shadowColor", p.comp) + ";";
}, function (p) {
  return mapProps(p);
}); // font: unset;
// font-family: inherit;

var BasicPropTypes = {};
BasicStyles.reduce(function (obj, key) {
  BasicPropTypes[key] = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
});
var ColorPropTypes = {};
ColorStyles$1.reduce(function (obj, key) {
  BasicPropTypes[key] = PropTypes.string;
  BasicPropTypes[key + "Lightness"] = PropTypes.number;
});
Box.propTypes = _extends({
  shadow: PropTypes.number,
  shadowOpacity: PropTypes.number,
  shadowColor: PropTypes.string
}, BasicPropTypes, ColorPropTypes);
console.log(Box.propTypes);

var _templateObject$1 = taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n"], ["\n  width: 100%;\n  position: relative;\n"]),
    _templateObject2 = taggedTemplateLiteral(["\n  flex-direction: row;\n"], ["\n  flex-direction: row;\n"]),
    _templateObject3 = taggedTemplateLiteral(["\n  flex: 1;\n  transform: ", ";\n"], ["\n  flex: 1;\n  transform: ", ";\n"]),
    _templateObject4 = taggedTemplateLiteral(["\n  position: absolute;\n  left: ", ";\n  right: ", ";\n  bottom: ", ";\n  top: ", ";\n  display: flex;\n  justify-content: center;\n  flex-direction: ", ";\n  width: ", ";\n  height: ", ";\n"], ["\n  position: absolute;\n  left: ", ";\n  right: ", ";\n  bottom: ", ";\n  top: ", ";\n  display: flex;\n  justify-content: center;\n  flex-direction: ", ";\n  width: ", ";\n  height: ", ";\n"]);

var Root = styled(Box)(_templateObject$1);
var Wrap = styled(ScrollView)(_templateObject2);
var Content = styled(Box)(_templateObject3, function (p) {
  return "scale(" + (p.scaleValue || 1) + ")";
});
var Dots = styled(Box)(_templateObject4, function (p) {
  return p.dotsPosition !== "right" ? "0px" : "auto";
}, function (p) {
  return p.dotsPosition === "right" ? "0px" : "auto";
}, function (p) {
  return p.dotsPosition === "bottom" ? "0px" : "auto";
}, function (p) {
  return p.dotsPosition !== "bottom" ? "0px" : "auto";
}, function (p) {
  return p.dotsPosition === "bottom" || p.dotsPosition === "top" ? "row" : "column";
}, function (p) {
  return p.dotsPosition === "bottom" || p.dotsPosition === "top" ? "100%" : "auto";
}, function (p) {
  return p.dotsPosition === "bottom" || p.dotsPosition === "top" ? "auto" : "100%";
});
var AnimatedWrap = animated(Wrap);
var AnimatedContent = animated(Content);

var Comp = function Comp(props) {
  var onSwipe = props.onSwipe,
      onSwipeEnd = props.onSwipeEnd,
      index = props.index,
      swipeIndex = props.swipeIndex,
      style = props.style,
      itemSize = props.itemSize,
      children = props.children,
      gap = props.gap,
      scale = props.scale,
      flex = props.flex,
      dots = props.dots,
      dotsPosition = props.dotsPosition,
      dotsOffset = props.dotsOffset,
      autoplay = props.autoplay,
      duration = props.duration,
      vertical = props.vertical,
      rest = objectWithoutProperties(props, ["onSwipe", "onSwipeEnd", "index", "swipeIndex", "style", "itemSize", "children", "gap", "scale", "flex", "dots", "dotsPosition", "dotsOffset", "autoplay", "duration", "vertical"]);
  var scrollRef = useRef(null);

  var _useState = useState({
    width: itemSize || 0,
    height: itemSize || 0,
    swipeIndex: 0,
    index: 0,
    offset: {
      x: 0,
      y: 0
    }
  }),
      _useState2 = slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    if (index !== state.index) {
      setState(_extends({}, state, {
        index: index,
        swipeIndex: index
      }));
    }

    if (swipeIndex !== state.swipeIndex) {
      setState(_extends({}, state, {
        swipeIndex: swipeIndex,
        offset: {
          x: swipeIndex * -state.width,
          y: 0
        }
      }));
    }
  }, [index, swipeIndex]);
  useEffect(function () {
    scrollRef.current.scrollTo({
      x: vertical ? 0 : state.index * state.width,
      y: vertical ? state.index * state.width : 0,
      animated: true
    });
  }, [state.index]);
  useEffect(function () {
    if (autoplay) {
      var interval = setInterval(function () {
        var maxIndex = React.Children.count(children) - 1;
        var newIndex = state.index + 1 > maxIndex ? 0 : state.index + 1;
        setState(_extends({}, state, {
          index: newIndex
        }));
      }, duration);
      return function () {
        return clearInterval(interval);
      };
    } else {
      return function () {
        return null;
      };
    }
  }); // const contentSpring = useSpring({
  //   to: {
  //     left: state.swipeIndex * -state.width,
  //     moveX: state.moveX,
  //     swipeIndex: state.swipeIndex
  //   },
  //   config: { mass: 1, tension: 300, friction: 30 },
  //   immediate: name => state.swipe && name === "moveX"
  // });

  return React.createElement(Root, _extends({
    onLayout: function onLayout(_ref) {
      var nativeEvent = _ref.nativeEvent;
      var width = itemSize || nativeEvent.layout.width;
      setState(_extends({}, state, {
        width: width,
        offset: {
          x: vertical ? 0 : state.index * width,
          y: vertical ? state.index * width : 0
        }
      }));
    },
    style: [flex, {
      flex: flex || undefined
    }]
  }, rest), React.createElement(Wrap, {
    ref: scrollRef,
    horizontal: !vertical,
    pagingEnabled: true,
    snapToInterval: state.width,
    decelerationRate: "fast",
    snapToAlignment: "left",
    automaticallyAdjustContentInsets: false,
    scrollsToTop: false,
    bounces: true,
    scrollEventThrottle: 16,
    showsHorizontalScrollIndicator: false,
    showsVerticalScrollIndicator: false,
    directionalLockEnabled: true,
    contentOffset: state.offset,
    alwaysBounceVertical: false,
    keyboardDismissMode: "on-drag",
    onScroll: function onScroll(_ref2) {
      var nativeEvent = _ref2.nativeEvent; //if (Platform.OS === "web") disablePageScroll();

      if (!vertical) {
        var swipeIndex = nativeEvent.contentOffset.x / state.width;
      } else {
        var swipeIndex = nativeEvent.contentOffset.y / state.width;
      }

      if (onSwipe) onSwipe(swipeIndex);
      setState(_extends({}, state, {
        swipeIndex: swipeIndex
      }));
    },
    onMomentumScrollEnd: function onMomentumScrollEnd(_ref3) {
      var nativeEvent = _ref3.nativeEvent; //if (Platform.OS === "web") enablePageScroll();

      var indexNew = Math.round(nativeEvent.contentOffset.x / state.width);

      if (!vertical) {
        var indexNew = Math.round(nativeEvent.contentOffset.x / state.width);
      } else {
        var indexNew = Math.round(nativeEvent.contentOffset.y / state.width);
      }

      if (onSwipeEnd) onSwipeEnd(indexNew);
      setState(_extends({}, state, {
        index: indexNew
      }));
    },
    style: {
      flex: flex || undefined,
      flexDirection: vertical ? "column" : "row"
    },
    contentContainerStyle: {
      width: vertical ? "100%" : "auto"
    }
  }, React.Children.map(children, function (child, index) {
    return React.createElement(AnimatedContent, {
      style: {
        padding: gap / 2,
        width: vertical ? "100%" : state.width,
        height: vertical ? state.width : "100%"
      }
    }, child);
  })), dots && React.createElement(Dots, {
    dotsPosition: dotsPosition,
    dotsOffset: dotsOffset,
    style: defineProperty({}, dotsPosition, dotsOffset)
  }, React.createElement(Select$1, {
    style: {
      width: 70,
      height: 6,
      backgroundColor: "rgba(0,0,0,0.2)",
      transform: [{
        rotate: vertical ? "90deg" : "0deg"
      }]
    },
    onChange: function onChange(value, index) {
      setState(_extends({}, state, {
        index: index
      }));
    },
    borderRadius: 3,
    value: "" + state.index,
    swipeIndex: state.swipeIndex,
    options: React.Children.map(children, function (child, index) {
      return "" + index;
    }),
    hideLabels: true
  })));
};

Comp.propTypes = {
  index: PropTypes.number,
  swipeIndex: PropTypes.number,
  threshold: PropTypes.number,
  hysteresis: PropTypes.number,
  children: PropTypes.node.isRequired,
  onSwipe: PropTypes.func,
  onSwipeEnd: PropTypes.func,
  scale: PropTypes.bool
};
Comp.defaultProps = {
  vertical: false,
  flex: undefined,
  index: 0,
  gap: 0,
  swipeIndex: 0,
  threshold: 5,
  hysteresis: 0.6,
  dotsPosition: "bottom",
  dotsOffset: 20,
  dots: false,
  autoplay: false,
  duration: 3000
};

var _templateObject$2 = taggedTemplateLiteral(["\n  position: relative;\n  height: 45px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", "px;\n\n  flex-direction: row;\n  justify-content: space-between;\n  overflow: hidden;\n"], ["\n  position: relative;\n  height: 45px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", "px;\n\n  flex-direction: row;\n  justify-content: space-between;\n  overflow: hidden;\n"]),
    _templateObject2$1 = taggedTemplateLiteral(["\n  flex: 1;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n"], ["\n  flex: 1;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n"]),
    _templateObject3$1 = taggedTemplateLiteral(["\n  font-size: 14px;\n  color: ", ";\n"], ["\n  font-size: 14px;\n  color: ", ";\n"]),
    _templateObject4$1 = taggedTemplateLiteral(["\n  position: absolute;\n  height: ", "px;\n  left: 0;\n  top: 0;\n  background-color: ", ";\n  border-radius: ", "px;\n"], ["\n  position: absolute;\n  height: ", "px;\n  left: 0;\n  top: 0;\n  background-color: ", ";\n  border-radius: ", "px;\n"]),
    _templateObject5 = taggedTemplateLiteral(["\n  position: relative;\n  flex: 1;\n  height: 500px;\n  overflow: hidden;\n"], ["\n  position: relative;\n  flex: 1;\n  height: 500px;\n  overflow: hidden;\n"]),
    _templateObject6 = taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n"], ["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n"]);

var Select = styled(Pan)(_templateObject$2, function (p) {
  return getColorSchema(p, getProp(p, "mode", "select"), "light").background;
}, function (p) {
  return getProp(p, "borderRadius", "select");
});
var Item = styled(TouchableOpacity)(_templateObject2$1);
var Label = styled(Text)(_templateObject3$1, function (p) {
  return p.active ? "#FFF" : getColorSchema(p, getProp(p, "mode", "select"), "light").text;
});
var Indicator = styled(View)(_templateObject4$1, function (p) {
  return getProp(p, "indicatorHeight", "select");
}, function (p) {
  return getColorSchema(p, getProp(p, "mode", "select"), "background").background;
}, function (p) {
  return getProp(p, "borderRadius", "select");
});
var ContentWrap = styled(Pan)(_templateObject5);
var Content$1 = styled(View)(_templateObject6);
var AnimatedIndicator = animated(Indicator);
var AnimatedContent$1 = animated(Content$1);

var isString = function isString(option) {
  return typeof option === "string" ? true : false;
};

var Comp$1 = function Comp$$1(props) {
  var value = props.value,
      onChange = props.onChange,
      style = props.style,
      options = props.options,
      children = props.children,
      indicatorHeight = props.indicatorHeight,
      borderRadius = props.borderRadius,
      swipeIndex = props.swipeIndex,
      hideLabels = props.hideLabels,
      rest = objectWithoutProperties(props, ["value", "onChange", "style", "options", "children", "indicatorHeight", "borderRadius", "swipeIndex", "hideLabels"]);
  var selectedIndex = options.findIndex(function (option) {
    return option === value || option.value === value;
  });

  var _useState = useState({
    moveX: 0,
    moveContentX: 0,
    width: 0,
    swipeIndex: 0,
    index: selectedIndex || 0,
    swipe: false
  }),
      _useState2 = slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var width = state.width / options.length;
  useEffect(function () {
    if (selectedIndex !== state.index) {
      setState(_extends({}, state, {
        index: selectedIndex,
        moveX: selectedIndex * width,
        swipeIndex: selectedIndex
      }));
    }

    if (swipeIndex !== state.swipeIndex) {
      setState(_extends({}, state, {
        moveX: swipeIndex * width,
        swipeIndex: swipeIndex
      }));
    }
  }, [selectedIndex, swipeIndex]);
  var springStyle = useSpring({
    x: Math.round(state.swipeIndex * width),
    moveX: state.moveX,
    width: width + "px",
    config: {
      mass: 1,
      tension: 300,
      friction: 30
    },
    immediate: function immediate(name) {
      return state.swipe && name === "moveX";
    }
  });
  var TabsComp = React.createElement(Select, {
    style: style,
    borderRadius: borderRadius,
    onLayout: function onLayout(_ref) {
      var nativeEvent = _ref.nativeEvent;
      var width = state.width / options.length;
      setState(_extends({}, state, {
        width: nativeEvent.layout.width,
        moveX: width * state.index
      }));
    },
    onStart: function onStart() {
      console.log("start");
      setState(_extends({}, state, {
        swipe: true
      }));
    },
    onSwipe: function onSwipe(direction, panState) {
      var dx = state.index * width + panState.dx;
      var swipeIndex = springStyle.moveX.interpolate([0, state.width], [0, options.length]).getAnimatedValue();
      setState(_extends({}, state, {
        moveX: dx,
        swipeIndex: swipeIndex
      }));
    },
    onSwipeEnd: function onSwipeEnd(direction, gestureState) {
      var _props$threshold = props.threshold,
          threshold = _props$threshold === undefined ? 0 : _props$threshold;
      var vx = gestureState.vx;
      var swipeIndex = Math.round(state.swipeIndex); // Quick movement

      if (Math.abs(vx) * 10 > threshold) {
        if (vx > 0) {
          swipeIndex = swipeIndex + 1;
        } else {
          swipeIndex = swipeIndex - 1;
        }
      }

      if (swipeIndex < 0) {
        swipeIndex = 0;
      } else if (swipeIndex > options.length - 1) {
        swipeIndex = options.length - 1;
      }

      setState(_extends({}, state, {
        moveX: swipeIndex * width,
        index: swipeIndex,
        swipeIndex: swipeIndex,
        swipe: false
      }));
    }
  }, value && React.createElement(AnimatedIndicator, {
    style: {
      left: state.swipe ? state.swipeIndex * width : springStyle.x,
      width: width
    },
    indicatorHeight: indicatorHeight || style.height,
    borderRadius: borderRadius
  }), options.map(function (option, index) {
    return React.createElement(Item, {
      active: state.index === index,
      activeOpacity: state.index === index ? 1 : 0.6,
      onPress: function onPress() {
        setState(_extends({}, state, {
          index: index,
          moveX: index * width,
          swipeIndex: index
        }));

        if (onChange) {
          onChange(isString(option) ? option : option.value);
        }
      },
      key: "item-" + index
    }, !hideLabels && React.createElement(Label, {
      active: Math.round(state.swipeIndex) === index
    }, isString(option) ? option : option.label));
  }));

  if (children) {
    return React.createElement(View, null, TabsComp, React.createElement(Comp, {
      index: state.index,
      swipeIndex: state.swipeIndex,
      onSwipe: function onSwipe(swipeIndex) {
        console.log({
          swipeIndex: swipeIndex
        });
        setState(_extends({}, state, {
          swipeIndex: swipeIndex
        }));
      },
      onSwipeEnd: function onSwipeEnd(index) {
        console.log({
          index: index
        });
        setState(_extends({}, state, {
          index: index,
          swipeIndex: index
        }));
      }
    }, children));
  } else {
    return TabsComp;
  }
};

Comp$1.defaultProps = {
  threshold: 5
};
var Select$1 = withTheme(Comp$1);

var _templateObject$3 = taggedTemplateLiteral(["\n  flex: ", ";\n  display: ", ";\n"], ["\n  flex: ", ";\n  display: ", ";\n"]);

var Flex = styled(Box)(_templateObject$3, function (p) {
  return p.inline ? "0" : "1";
}, function (p) {
  return p.inline ? "inline-flex" : "flex";
});
Flex.propTypes = {
  inline: PropTypes.bool
};
Flex.defaultProps = {
  flex: "1"
};

var _templateObject$4 = taggedTemplateLiteral(["\n  display: ", ";\n"], ["\n  display: ", ";\n"]);

var Block = styled(Box)(_templateObject$4, function (p) {
  return p.inline ? "inline-block" : "block";
});
Block.propTypes = {
  inline: PropTypes.bool
};

var Text$1 = function Text$1(_ref) {
  var children = _ref.children,
      comp = _ref.comp,
      rest = objectWithoutProperties(_ref, ["children", "comp"]);
  return React.createElement(Block, _extends({
    as: Text
  }, rest, {
    comp: comp || "text"
  }), children);
};

var styles = StyleSheet.create({
  imageOverlay: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    top: 0
  }
});

var Comp$2 = function (_React$Component) {
  inherits(Comp, _React$Component);

  function Comp(props) {
    classCallCheck(this, Comp);

    var _this = possibleConstructorReturn(this, (Comp.__proto__ || Object.getPrototypeOf(Comp)).call(this, props));

    _this.thumbnailAnimated = new Animated.Value(0);
    _this.imageAnimated = new Animated.Value(0);

    _this.getSize = function () {
      Image.getSize(_this.props.source.uri, function (width, height) {
        return _this.setState({
          aspect: width / height
        }, function () {
          _this.setSize();
        });
      });
    };

    _this.handleThumbnailLoad = function () {
      Animated.timing(_this.thumbnailAnimated, {
        toValue: 1
      }).start();

      _this.getSize();
    };

    _this.onImageLoad = function () {
      Animated.timing(_this.imageAnimated, {
        toValue: 1
      }).start();

      _this.getSize();

      if (_this.props.onImageLoad) _this.props.onImageLoad();
    };

    _this.setSize = function () {
      var width = !_this.props.width ? _this.state.layoutWidth : _this.props.width;
      var height = !_this.props.height ? _this.state.layoutWidth / _this.state.aspect : _this.props.height;

      _this.setState({
        width: width,
        height: height
      });
    };

    _this.state = {
      width: props.width,
      height: props.height,
      aspect: null
    };
    return _this;
  }

  createClass(Comp, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          thumbnailSource = _props.thumbnailSource,
          source = _props.source,
          style = _props.style,
          blurred = _props.blurred,
          width = _props.width,
          height = _props.height,
          full = _props.full,
          resizeMode = _props.resizeMode,
          blurRadius = _props.blurRadius,
          rest = objectWithoutProperties(_props, ["thumbnailSource", "source", "style", "blurred", "width", "height", "full", "resizeMode", "blurRadius"]);
      return React.createElement(Box, _extends({
        onLayout: function onLayout(_ref) {
          var nativeEvent = _ref.nativeEvent;

          _this2.setState({
            layoutWidth: nativeEvent.layout.width
          }, function () {
            _this2.setSize();
          });
        },
        style: style
      }, rest, {
        width: full ? "100%" : this.state.width || "100%",
        height: this.state.height || "auto"
      }), React.createElement(Animated.Image, _extends({}, rest, {
        width: "100%",
        height: this.state.height || "auto",
        source: thumbnailSource || source,
        resizeMode: resizeMode,
        blurRadius: blurRadius || 5,
        style: [style, {
          opacity: this.thumbnailAnimated
        }],
        onLoad: this.handleThumbnailLoad
      })), React.createElement(Animated.Image, _extends({}, rest, {
        width: "100%",
        height: this.state.height || "auto",
        source: source,
        resizeMode: resizeMode,
        blurRadius: blurRadius || 0,
        style: [styles.imageOverlay, {
          opacity: this.imageAnimated
        }, style],
        onLoad: this.onImageLoad
      })));
    }
  }]);
  return Comp;
}(React.Component);

Comp$2.propTypes = {
  onImageLoad: PropTypes.func
};

var _templateObject$5 = taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 0;\n  overflow: hidden;\n"], ["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 0;\n  overflow: hidden;\n"]);

var Gradient = styled(Box)(_templateObject$5);

var getID = function getID() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(2, 10);
};

var Comp$3 = function Comp(props) {
  var children = props.children,
      style = props.style,
      rest = objectWithoutProperties(props, ["children", "style"]);
  var id = getID();
  var colors = getProp(props, "colors", "gradient");
  return React.createElement(Gradient, _extends({
    style: style
  }, rest), React.createElement(Svg, {
    height: "100%",
    width: "100%"
  }, React.createElement(Defs, null, React.createElement(LinearGradient, {
    id: id,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, colors && colors.length > 0 ? colors.map(function (color, index) {
    return React.createElement(Stop, {
      key: "color-" + color + "-" + index,
      offset: index / (colors.length - 1) * 100 + "%",
      style: {
        stopColor: color,
        stopOpacity: "1"
      }
    });
  }) : null)), React.createElement(Rect, {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: "url(#" + id + ")"
  })), children);
};

Comp$3.propTypes = {
  colors: PropTypes.array,
  style: PropTypes.object
};
var Gradient$1 = withTheme(Comp$3);

var _templateObject$6 = taggedTemplateLiteral(["\n  stroke: ", ";\n"], ["\n  stroke: ", ";\n"]);

var Track = styled(Path)(_templateObject$6, function (p) {
  return getProp(p, "trackColor", "progress");
});
var Circle = styled(Path)(_templateObject$6, function (p) {
  return getProp(p, "circleColor", "progress");
});
var AnimatedView = animated(Block);

var polarToCartesian = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
};

var circlePath = function circlePath(x, y, radius, startAngle, endAngle) {
  var start = polarToCartesian(x, y, radius, endAngle * 0.9999);
  var end = polarToCartesian(x, y, radius, startAngle);
  var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
  var d = ["M", start.x, start.y, "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y];
  return d.join(" ");
};

var clampFill = function clampFill(fill) {
  return Math.min(100, Math.max(0, fill));
};

var PathComp = function (_React$PureComponent) {
  inherits(PathComp, _React$PureComponent);

  function PathComp() {
    classCallCheck(this, PathComp);
    return possibleConstructorReturn(this, (PathComp.__proto__ || Object.getPrototypeOf(PathComp)).apply(this, arguments));
  }

  createClass(PathComp, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          progress = _props.progress,
          trackWidth = _props.trackWidth,
          circleWidth = _props.circleWidth,
          lineCap = _props.lineCap,
          size = _props.size,
          angle = _props.angle,
          rotate = _props.rotate,
          rest = objectWithoutProperties(_props, ["progress", "trackWidth", "circleWidth", "lineCap", "size", "angle", "rotate"]);
      return React.createElement(Circle, _extends({
        d: circlePath(size / 2, size / 2, size / 2 - (circleWidth >= trackWidth ? circleWidth : trackWidth) / 2, 0, angle * clampFill(progress) / 100),
        strokeWidth: circleWidth,
        strokeLinecap: lineCap,
        fill: "transparent"
      }, rest));
    }
  }]);
  return PathComp;
}(React.PureComponent);

var AnimatedPath = animated(PathComp);

var Comp$4 = function Comp(props) {
  var progress = props.progress,
      size = props.size,
      trackWidth = props.trackWidth,
      circleWidth = props.circleWidth,
      loading = props.loading,
      lineCap = props.lineCap,
      angle = props.angle,
      style = props.style,
      rotate = props.rotate,
      rest = objectWithoutProperties(props, ["progress", "size", "trackWidth", "circleWidth", "loading", "lineCap", "angle", "style", "rotate"]);

  var _useState = useState(1),
      _useState2 = slicedToArray(_useState, 2),
      running = _useState2[0],
      setRunning = _useState2[1]; // 0 reset, 1 run


  useEffect(function () {
    if (running === 0) {
      setRunning(1);
    }
  }, [running === 0]);

  var _useSpring = useSpring({
    from: {
      bla: 0
    },
    to: {
      bla: progress || 0
    },
    config: {
      duration: 300
    }
  }),
      bla = _useSpring.bla;

  var _useSpring2 = useSpring({
    from: {
      loadingRotate: 0
    },
    to: {
      loadingRotate: 360
    },
    reset: running === 0,
    onRest: function onRest() {
      return loading ? setRunning(0) : null;
    },
    config: {
      duration: 1000
    }
  }),
      loadingRotate = _useSpring2.loadingRotate;

  var backgroundPath = circlePath(size / 2, size / 2, size / 2 - (circleWidth >= trackWidth ? circleWidth : trackWidth) / 2, 0, angle);
  return React.createElement(AnimatedView, _extends({
    width: size,
    height: size,
    style: loading ? {
      transform: loadingRotate.interpolate(function (l) {
        return "rotate(" + l + "deg)";
      })
    } : {
      transform: [{
        rotate: rotate + "deg"
      }]
    },
    inline: true
  }, rest), React.createElement(Svg, {
    width: size,
    height: size,
    style: {
      backgroundColor: "transparent"
    }
  }, React.createElement(G, {
    rotate: rotate,
    originX: size / 2,
    originY: size / 2
  }, React.createElement(Track, _extends({
    d: backgroundPath,
    strokeWidth: trackWidth,
    strokeLinecap: lineCap,
    fill: "transparent",
    strokeDashoffset: 50
  }, rest)), React.createElement(AnimatedPath, _extends({}, props, {
    progress: loading ? loadingRotate.interpolate([0, 180, 360], [75, 25, 75]) : bla
  })))));
};

Comp$4.defaultProps = {
  showPercentage: true,
  showPercentageSymbol: true,
  size: 100,
  trackWidth: 30,
  circleWidth: 30,
  angle: 360,
  rotate: 0,
  loading: false,
  lineCap: "round" //"round" : "butt"

};
Comp$4.propTypes = {
  progress: PropTypes.number,
  trackWidth: PropTypes.number,
  circleWidth: PropTypes.number,
  rotate: PropTypes.number,
  angle: PropTypes.number,
  size: PropTypes.number,
  trackColor: PropTypes.string,
  lineCap: PropTypes.string,
  circleColor: PropTypes.string,
  loading: PropTypes.bool,
  style: PropTypes.object
};

var _templateObject$7 = taggedTemplateLiteral(["\n  padding: 0 ", "px;\n  height: ", "px;\n  width: auto;\n  background-color: ", ";\n  opacity: ", ";\n  align-items: center;\n  justify-content: center;\n"], ["\n  padding: 0 ", "px;\n  height: ", "px;\n  width: auto;\n  background-color: ", ";\n  opacity: ", ";\n  align-items: center;\n  justify-content: center;\n"]),
    _templateObject2$2 = taggedTemplateLiteral(["\n  position: relative;\n  z-index: 10;\n  color: ", ";\n  font-size: ", "px;\n"], ["\n  position: relative;\n  z-index: 10;\n  color: ", ";\n  font-size: ", "px;\n"]); // import styles from "./styles.css";


var Button = styled(Flex)(_templateObject$7, function (p) {
  return getProp(p, "size", "button") / 2;
}, function (p) {
  return getProp(p, "size", "button");
}, function (p) {
  return getProp(p, "backgroundColor", "button");
}, function (p) {
  return p.disabled && !p.loading ? 0.5 : 1;
});
var ButtonText = styled(Text$1)(_templateObject2$2, function (p) {
  return getColorSchema(p, getProp(p, "mode", "button"), p.light ? "light" : "background").text;
}, function (p) {
  return getProp(p, "size", "button") / 3.25;
});

var Comp$5 = function Comp(props) {
  var mode = props.mode,
      children = props.children,
      style = props.style,
      onPress = props.onPress,
      inline = props.inline,
      activeOpacity = props.activeOpacity,
      disabled = props.disabled,
      light = props.light,
      colors = props.colors,
      color = props.color,
      loading = props.loading,
      rest = objectWithoutProperties(props, ["mode", "children", "style", "onPress", "inline", "activeOpacity", "disabled", "light", "colors", "color", "loading"]);
  return React.createElement(Button, _extends({
    as: TouchableOpacity,
    style: style,
    disabled: disabled || loading,
    loading: loading,
    onPress: disabled ? null : onPress || null,
    onMouseEnter: function onMouseEnter() {
      return console.log("hover");
    },
    activeOpacity: getProp(props, "activeOpacity", "button"),
    inline: getProp(props, "inline", "button"),
    comp: "button"
  }, rest), React.createElement(Gradient$1, {
    borderRadius: props.borderRadius,
    opacity: props.disabled ? 0.25 : 1
  }), loading ? React.createElement(Comp$4, {
    size: 20,
    trackWidth: 2,
    circleWidth: 2,
    trackColor: "transparent",
    circleColor: "#FFF",
    loading: true
  }) : React.createElement(ButtonText, {
    numberOfLines: 1,
    color: color
  }, children));
};

Comp$5.propTypes = {
  mode: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
  light: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
  colors: PropTypes.array
};
Comp$5.defaultProps = {
  loading: false,
  borderRadius: 22
};
console.log(Comp$5.propTypes);
var Button$1 = withTheme(Comp$5);
var AnimatedBox = animated(Box);

var Comp$6 = function Comp(props) {
  var from = props.from,
      to = props.to,
      children = props.children,
      isVisible = props.isVisible,
      stayVisible = props.stayVisible,
      onVisible = props.onVisible,
      delay = props.delay,
      reset = props.reset,
      reverse = props.reverse,
      config = props.config,
      style = props.style,
      as = props.as;

  var _useState = useState({
    active: onVisible ? false : true,
    wasActive: false
  }),
      _useState2 = slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var visible = state.active || isVisible;
  var aniStyle = useSpring({
    from: from,
    to: state.active ? to : from,
    config: config || undefined,
    delay: delay || 0,
    reset: reset || false,
    reverse: reverse || false
  });

  if (onVisible) {
    return React.createElement(Visible, {
      disabled: state.active,
      onChange: function onChange(visible) {
        if (visible && !state.active) {
          setState(_extends({}, state, {
            active: true
          }));
        } else if (!stayVisible) {
          setState(_extends({}, state, {
            active: false
          }));
        }
      }
    }, function (_ref) {
      var isVisible = _ref.isVisible;
      if (!isVisible) return null;
      return React.createElement(AnimatedBox, {
        as: as,
        style: aniStyle
      }, React.Children.only(children));
    });
  }

  return React.createElement(AnimatedBox, {
    as: as,
    style: aniStyle
  }, React.Children.only(children));
};

Comp$6.defaultProps = {
  stayVisible: true,
  from: {
    opacity: 0,
    transform: [{
      translateY: 30
    }]
  },
  to: {
    opacity: 1,
    transform: [{
      translateY: 0
    }]
  }
};

var _templateObject$8 = taggedTemplateLiteral(["\n  ", ";\n  flex-direction: row;\n"], ["\n  ", ";\n  flex-direction: row;\n"]),
    _templateObject2$3 = taggedTemplateLiteral(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"]);

var Headline = styled(Text$1)(_templateObject$8, function (p) {
  return Platform.OS === "web" ? "inline-block" : "flex";
});
var Span = styled(Text$1)(_templateObject2$3);
var AnimatedSpan = animated(Span);

var Comp$7 = function Comp(_ref) {
  var level = _ref.level,
      children = _ref.children,
      style = _ref.style,
      animated$$1 = _ref.animated,
      rest = objectWithoutProperties(_ref, ["level", "children", "style", "animated"]);

  if (animated$$1) {
    var splittedString = children.split("");
    return React.createElement(View, {
      style: {
        flexDirection: "row"
      }
    }, splittedString.map(function (char, index) {
      return React.createElement(Comp$6, {
        as: Platform.OS === "web" ? undefined : undefined,
        key: index + "-" + char,
        delay: index * 25,
        config: {
          mass: 1,
          tension: 180,
          friction: 12
        }
      }, React.createElement(Headline, _extends({
        style: style,
        accessibilityRole: Platform.OS === "web" ? "heading" : undefined,
        "aria-level": level,
        comp: "headline"
      }, rest), char));
    }));
  }

  return React.createElement(Headline, _extends({
    accessibilityRole: Platform.OS === "web" ? "heading" : undefined,
    "aria-level": level,
    style: style,
    comp: "headline"
  }, rest), children);
}; // const transitions = useTransition(text, null, {
//   from: { opacity: 0 },
//   enter: { opacity: 1 },
//   leave: { opacity: 0 }
// })
// return transitions.map(({ item, key, props }) => (
//   <animated.div style={props}>{item}</animated.div>
// ))


Comp$7.propTypes = {
  children: PropTypes.node,
  as: PropTypes.string,
  style: PropTypes.object,
  from: PropTypes.object,
  to: PropTypes.object
};

var _templateObject$9 = taggedTemplateLiteral(["\n  position: relative;\n  display: ", ";\n  width: ", "px;\n  height: ", "px;\n  padding: ", "px;\n  border-radius: ", "px;\n  background-color: rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n"], ["\n  position: relative;\n  display: ", ";\n  width: ", "px;\n  height: ", "px;\n  padding: ", "px;\n  border-radius: ", "px;\n  background-color: rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n"]),
    _templateObject2$4 = taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"]),
    _templateObject3$2 = taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  width: ", "px;\n  height: ", "px;\n  margin-top: -", "px;\n  border-radius: 30px;\n  background-color: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n"], ["\n  position: absolute;\n  top: 50%;\n  width: ", "px;\n  height: ", "px;\n  margin-top: -", "px;\n  border-radius: 30px;\n  background-color: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n"]);

var Switcher = styled(Block)(_templateObject$9, function (p) {
  return Platform.OS === "web" ? "inline-block" : "flex";
}, function (p) {
  return getProp(p, "circleSize", "switch") * 2 + getProp(p, "borderSize", "switch") * 2;
}, function (p) {
  return getProp(p, "circleSize", "switch") + getProp(p, "borderSize", "switch") * 2;
}, function (p) {
  return getProp(p, "borderSize", "switch");
}, function (p) {
  return getProp(p, "borderRadius", "switch");
});
var SwitcherTrack = styled(Block)(_templateObject2$4);
var Circle$1 = styled(View)(_templateObject3$2, function (p) {
  return getProp(p, "circleSize", "switch");
}, function (p) {
  return getProp(p, "circleSize", "switch");
}, function (p) {
  return getProp(p, "circleSize", "switch") / 2;
});
var AnimatedCircle = animated(Circle$1);

var Comp$8 = function Comp(props) {
  var value = props.value,
      onChange = props.onChange,
      circleSize = props.circleSize,
      style = props.style,
      rest = objectWithoutProperties(props, ["value", "onChange", "circleSize", "style"]);

  var _useState = useState(value || false),
      _useState2 = slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var spring = useSpring({
    to: {
      left: active ? circleSize : 0
    }
  });
  useEffect(function () {
    setActive(value);
  }, [value]);
  return React.createElement(Switcher, _extends({
    as: TouchableOpacity,
    style: style,
    activeOpacity: 0.8,
    circleSize: circleSize,
    onPress: function onPress() {
      var newValue = !active;
      setActive(newValue);
      setTimeout(function () {
        if (onChange) {
          onChange(newValue);
        }
      }, 299);
    }
  }, rest), React.createElement(SwitcherTrack, null, React.createElement(AnimatedCircle, {
    circleSize: circleSize,
    style: spring
  })));
}; // class Comp extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       value: props.value
//     };
//   }
//   render() {
//     const { value, onChange, circleSize, style } = this.props;
//     console.log(circleSize);
//     const width = getProp(this.props, "circleSize", "switch") * 2 + 10;
//     return (
//       <Spring
//         to={{ left: this.state.value ? width / 2 : 5 }}
//         config={{ duration: 200 }}
//       >
//         {props => {
//           return (
//             <Switcher
//               style={style}
//               circleSize={circleSize}
//               activeOpacity={0.8}
//               onPress={() => {
//                 this.setState({ value: !this.state.value });
//                 // setTimeout(() => {
//                 //   if (onChange) {
//                 //     onChange(!value);
//                 //   }
//                 // }, 299);
//               }}
//             >
//               {this.state.value && <Gradient />}
//               <AnimatedCircle
//                 circleSize={circleSize}
//                 style={{ transform: [{ translateX: props.left }] }}
//               />
//             </Switcher>
//           );
//         }}
//       </Spring>
//     );
//   }
// }


Comp$8.propTypes = {
  value: PropTypes.bool,
  style: PropTypes.object,
  circleSize: PropTypes.number,
  borderSize: PropTypes.number,
  onChange: PropTypes.func
};
Comp$8.defaultProps = {
  circleSize: 30
};

var _templateObject$a = taggedTemplateLiteral(["\n  align-self: stretch;\n  flex-direction: row;\n"], ["\n  align-self: stretch;\n  flex-direction: row;\n"]),
    _templateObject2$5 = taggedTemplateLiteral(["\n  align-self: stretch;\n  flex-direction: row;\n  padding: 15px;\n  background-color: ", ";\n"], ["\n  align-self: stretch;\n  flex-direction: row;\n  padding: 15px;\n  background-color: ", ";\n"]);

var isOdd = function isOdd(num) {
  return num % 2;
};

var Row = styled(Flex)(_templateObject$a);
var HeadItem = styled(Flex)(_templateObject2$5, function (p) {
  return getProp(p, "headBackground", "table");
});
var Item$1 = styled(Flex)(_templateObject2$5, function (p) {
  return getProp(p, "even", "table") === true && isOdd(p.index) === 0 ? "transparent" : getProp(p, "bodyBackground", "table");
});
var Label$1 = styled(Text$1)(_templateObject$a);

var Comp$9 = function Comp(props) {
  var keys = props.keys,
      data = props.data,
      style = props.style,
      even = props.even,
      rest = objectWithoutProperties(props, ["keys", "data", "style", "even"]);
  return React.createElement(Block, _extends({
    style: style
  }, rest), React.createElement(Row, null, keys && keys.map(function (key) {
    return React.createElement(HeadItem, {
      key: key + "-head"
    }, React.createElement(Label$1, null, key));
  })), data && data.map(function (item, index) {
    return React.createElement(Row, null, keys.map(function (key) {
      return React.createElement(Item$1, {
        key: key + "-" + index + "-body",
        index: index,
        even: even
      }, React.createElement(Label$1, null, getObjValue(item, key)));
    }));
  }));
};

Comp$9.propTypes = {
  keys: PropTypes.array,
  data: PropTypes.array,
  style: PropTypes.object,
  headBackground: PropTypes.string,
  bodyBackground: PropTypes.string,
  even: PropTypes.bool
};

var _templateObject$b = taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  height: ", "px;\n  width: ", "px;\n  background-color: ", ";\n  border-radius: ", "px;\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  height: ", "px;\n  width: ", "px;\n  background-color: ", ";\n  border-radius: ", "px;\n"]),
    _templateObject2$6 = taggedTemplateLiteral(["\n  position: relative;\n  z-index: 10;\n  font-size: ", "px;\n  font-weight: bold;\n  color: ", ";\n"], ["\n  position: relative;\n  z-index: 10;\n  font-size: ", "px;\n  font-weight: bold;\n  color: ", ";\n"]),
    _templateObject3$3 = taggedTemplateLiteral(["\n  left: 0;\n  top: 0;\n  height: ", "px;\n  width: ", "px;\n  z-index: 0;\n  border-radius: ", "px;\n"], ["\n  left: 0;\n  top: 0;\n  height: ", "px;\n  width: ", "px;\n  z-index: 0;\n  border-radius: ", "px;\n"]);

var Avatar = styled(Block)(_templateObject$b, function (p) {
  return getProp(p, "size", "avatar");
}, function (p) {
  return getProp(p, "size", "avatar");
}, function (p) {
  return getColorSchema(p, getProp(p, getProp(p, "mode", "avatar"), "colors"), p.light ? "light" : "background").background;
}, function (p) {
  return getProp(p, "size", "avatar") / 2;
});
var Char = styled(Text$1)(_templateObject2$6, function (p) {
  return getProp(p, "size", "avatar") / 2.25;
}, function (p) {
  return getProp(p, "color", "avatar");
});
var Background = styled(Comp$2)(_templateObject3$3, function (p) {
  return getProp(p, "size", "avatar");
}, function (p) {
  return getProp(p, "size", "avatar");
}, function (p) {
  return getProp(p, "size", "avatar") / 2;
});

var Comp$a = function Comp(_ref) {
  var children = _ref.children,
      mode = _ref.mode,
      char = _ref.char,
      size = _ref.size,
      onPress = _ref.onPress,
      light = _ref.light,
      style = _ref.style,
      source = _ref.source,
      color = _ref.color,
      rest = objectWithoutProperties(_ref, ["children", "mode", "char", "size", "onPress", "light", "style", "source", "color"]);
  return React.createElement(Avatar, _extends({
    as: TouchableOpacity,
    style: style,
    light: light,
    mode: mode,
    size: size,
    onPress: onPress || null,
    onMouseEnter: function onMouseEnter() {
      return console.log("hover");
    },
    activeOpacity: onPress ? 0.6 : 1,
    comp: "avatar"
  }, rest), source ? React.createElement(Background, {
    source: source,
    width: size,
    height: size,
    resizeMode: "cover",
    position: "absolute"
  }) : null, children ? children : React.createElement(Char, {
    mode: mode,
    light: light,
    size: size,
    color: color
  }, char));
};

Comp$a.propTypes = {
  mode: PropTypes.string,
  char: PropTypes.string,
  size: PropTypes.number,
  source: PropTypes.object,
  onPress: PropTypes.func,
  light: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node.isRequired
};

var Portal = function (_Component) {
  inherits(Portal, _Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      el: null,
      target: null
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        el: document.createElement("div"),
        target: document.body
      }, function () {
        _this2.state.target.appendChild(_this2.state.el);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.state.target && this.state.target.removeChild(this.state.el);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;

      if (this.state.el) {
        return ReactDOM.createPortal(children, this.state.el);
      }

      return null;
    }
  }]);
  return Portal;
}(Component);

Portal.propTypes = {
  children: PropTypes.node.isRequired
};

var _templateObject$c = taggedTemplateLiteral(["\n  position: ", ";\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.25);\n"], ["\n  position: ", ";\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.25);\n"]),
    _templateObject2$7 = taggedTemplateLiteral(["\n  position: ", ";\n  transform: ", ";\n  left: ", ";\n  right: ", ";\n  bottom: ", ";\n  top: ", ";\n  background-color: #000;\n"], ["\n  position: ", ";\n  transform: ", ";\n  left: ", ";\n  right: ", ";\n  bottom: ", ";\n  top: ", ";\n  background-color: #000;\n"]),
    _templateObject3$4 = taggedTemplateLiteral(["\n  background-color: #fff;\n  width: 100%;\n  height: 100%;\n"], ["\n  background-color: #fff;\n  width: 100%;\n  height: 100%;\n"]),
    _templateObject4$2 = taggedTemplateLiteral(["\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  width: 6px;\n  height: 50px;\n  border-radius: 5px;\n  background-color: rgba(0, 0, 0, 0.1);\n"], ["\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  width: 6px;\n  height: 50px;\n  border-radius: 5px;\n  background-color: rgba(0, 0, 0, 0.1);\n"]),
    _templateObject5$1 = taggedTemplateLiteral(["\n  flex: 1;\n  ", "\n"], ["\n  flex: 1;\n  ", "\n"]);

var Backdrop = styled(View)(_templateObject$c, Platform.OS === "web" ? "fixed" : "absolute");
var PanWrap = styled(Pan)(_templateObject2$7, Platform.OS === "web" ? "fixed" : "absolute", function (p) {
  return p.position === "top" || p.position === "bottom" ? "translateY(" + p.move + "px)" : "translateX(" + p.move + "px)";
}, function (p) {
  return p.position !== "right" ? "0px" : "auto";
}, function (p) {
  return p.position === "right" ? "0px" : "auto";
}, function (p) {
  return p.position === "bottom" ? "0px" : "auto";
}, function (p) {
  return p.position !== "bottom" ? "0px" : "auto";
});
var Modal = styled(Box)(_templateObject3$4);
var Panner = styled(Box)(_templateObject4$2);
var Content$2 = styled(View)(_templateObject5$1, function (p) {
  return p.contentMoveStyle === "none" ? "" : p.contentMoveStyle === "padding" ? "padding-left: " + -p.move + "px" : "transform: " + function (p) {
    return p.modalPosition === "top" || p.modalPosition === "bottom" ? "translateY(" + -p.move + "px)" : "translateX(" + -p.move + "px)";
  } + ";";
});
var AnimatedBackdrop = animated(Backdrop);
var AnimatedContent$2 = animated(Content$2);
var AnimatedPan = animated(PanWrap);

var getMove = function getMove(position, width, height) {
  if (position === "left") {
    return -width;
  } else if (position === "right") {
    return width;
  } else if (position === "top") {
    return -height;
  } else if (position === "bottom") {
    return height;
  }
};

var Comp$b = function Comp(_ref) {
  var width = _ref.width,
      height = _ref.height,
      position = _ref.position,
      visible = _ref.visible,
      children = _ref.children,
      onClose = _ref.onClose,
      content = _ref.content,
      backdrop = _ref.backdrop,
      contentMove = _ref.contentMove,
      contentMoveStyle = _ref.contentMoveStyle,
      rest = objectWithoutProperties(_ref, ["width", "height", "position", "visible", "children", "onClose", "content", "backdrop", "contentMove", "contentMoveStyle"]);
  var Screen = Dimensions.get("window");

  var _useState = useState({
    width: width || Screen.width,
    height: height || Screen.height,
    swipe: false,
    move: visible ? 0 : getMove(position, Screen.width, Screen.height)
  }),
      _useState2 = slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    if (visible) {
      setState(_extends({}, state, {
        move: 0
      }));
    } else {
      setState(_extends({}, state, {
        move: getMove(position, state.width, state.height)
      }));
    }
  }, [visible]);

  var _useSpring = useSpring({
    from: {
      opacity: 0,
      move: getMove(position, state.width, state.height)
    },
    to: {
      opacity: 1,
      move: state.move
    },
    config: {
      mass: 1,
      tension: 300,
      friction: 30
    },
    immediate: function immediate(name) {
      return state.swipe && name === "move";
    }
  }),
      move = _useSpring.move,
      opacity = _useSpring.opacity;

  var autoOpacity = move.interpolate([0, getMove(position, state.width, state.height)], [1, 0]);
  var autoPosition = move.interpolate([0, getMove(position, state.width, state.height)], [getMove(position, state.width, state.height) * contentMove, 0]);
  console.log(position, state);
  var Wrap = Platform.OS === "web" ? Portal : Fragment;
  var contentStyle = "padding" + (position.charAt(0).toUpperCase() + position.slice(1));
  console.log({
    contentStyle: contentStyle
  });
  return React.createElement(Wrap, null, React.createElement(Fragment, null, children && React.createElement(AnimatedContent$2, {
    modalPosition: position,
    contentMoveStyle: contentMoveStyle,
    move: autoPosition
  }, children), backdrop && React.createElement(AnimatedBackdrop, {
    as: onClose ? TouchableOpacity : undefined,
    onPress: onClose || null,
    style: {
      opacity: autoOpacity
    },
    "aria-modal": "true",
    activeOpacity: 0.8,
    pointerEvents: visible ? "auto" : "none"
  }), React.createElement(AnimatedPan, {
    onLayout: function onLayout(_ref2) {
      var nativeEvent = _ref2.nativeEvent;
      console.log({
        width: nativeEvent.layout.width
      });
      setState(_extends({}, state, {
        width: nativeEvent.layout.width,
        height: nativeEvent.layout.height
      }));
    },
    style: {
      width: width,
      height: height
    },
    position: position,
    move: move,
    onStart: function onStart() {
      setState(_extends({}, state, {
        swipe: true
      }));
    },
    onSwipe: function onSwipe(direction, gestureState) {
      var dx = gestureState.dx,
          dy = gestureState.dy;
      console.log(gestureState, dx, dy);
      setState(_extends({}, state, {
        move: position === "top" || position === "bottom" ? dy : dx
      }));
    },
    onSwipeEnd: function onSwipeEnd(direction, gestureState) {
      var threshold = 0;
      var vx = gestureState.vx,
          vy = gestureState.vy;
      var visible = state.move < getMove(position, state.width, state.height) / 2 ? false : true;

      if (position === "right" || position === "bottom") {
        visible = state.move > getMove(position, state.width, state.height) / 2 ? false : true;
      } // Quick movement


      if (Math.abs(vx) * 10 > threshold) {
        if (vx > 0 && position === "left" || vx < 0 && position === "right" || vy < 0 && position === "top" || vy < 0 && position === "bottom") {
          visible = true;
        } else {
          visible = false;
        }
      }

      if (!visible && onClose) onClose();
      setState(_extends({}, state, {
        move: visible ? 0 : getMove(position, state.width, state.height),
        visible: visible,
        swipe: false
      }));
    }
  }, React.createElement(Modal, _extends({
    onPress: null,
    activeOpacity: 1,
    comp: "overlay"
  }, rest), React.createElement(Panner, null), content && content()))));
};

Comp$b.propTypes = {
  mode: PropTypes.string,
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
  light: PropTypes.bool,
  style: PropTypes.object
};
Comp$b.defaultProps = {
  contentMoveStyle: "transform",
  backdrop: true,
  position: "bottom",
  contentMove: 0.5
}; //Helper

export { UniProvider, Visible, Select$1 as Select, Box, Flex, Block, Text$1 as Text, Comp$2 as Image, Comp as Swiper, Button$1 as Button, Comp$7 as Headline, Gradient$1 as Gradient, Comp$8 as Switch, Comp$9 as Table, Comp$a as Avatar, Comp$4 as Progress, Comp$b as Overlay, Comp$6 as Animate };